(function($) {
    $(function() {
        $('.division-form').each(function(i, el) {
            var $form = $(el);
            $form.trigger('reset');

            var $languageFormGroups = $form.find('div[data-site-value]');
            var $siteGroupSitesFormGroups = $form.find('div[data-site-group-value]');

            function setActiveSite(site) {
                $languageFormGroups.hide();
                $form.find('div[data-site-value=\"' + site + '\"]').show();
            }

            function setActiveSiteGroup(siteGroup) {
                $siteGroupSitesFormGroups.hide();
                var $activeSiteGroup = $form.find('div[data-site-group-value=\"' + siteGroup + '\"]');
                $activeSiteGroup.show();

                var activeSite = $activeSiteGroup.find('select[name=\"sitegroupsites[]\"]').val();
                setActiveSite(activeSite);
            }

            var selectedSite = $form.data('selected-site');
            if ((selectedSite || '') !== '') {
                $siteGroupSitesFormGroups.each(function(i, el) {
                    var $siteGroupSitesFormGroup = $(el);
                    if ($siteGroupSitesFormGroup.find('select option[value=\"' + selectedSite + '\"]').length > 0) {
                        $siteGroupSitesFormGroup.find('select').val(selectedSite);
                        setActiveSite(selectedSite);
                    }
                });
            }

            var selectedLanguage = $form.data('selected-language');
            if ((selectedLanguage || '') !== '') {
                $languageFormGroups.each(function(i, el) {
                    var $languageFormGroup = $(el);
                    if ($languageFormGroup.find('select option[value=\"' + selectedLanguage + '\"]').length > 0) {
                        $languageFormGroup.find('select').val(selectedLanguage);
                    }
                });
            }

            var $siteSelect = $form.find('select[name=\"sitegroupsites[]\"]');
            $siteSelect.on('change',
                function(e) {
                    var val = $(e.target).val();
                    setActiveSite(val);
                });

            var $siteGroupSelect = $form.find('select[name=\"sitegroup\"]');
            $siteGroupSelect.on('change',
                function(e) {
                    var val = $(e.target).val();
                    setActiveSiteGroup(val);
                });
        });
        $('.nav-selector-dropdown>li').click(function () {
            document.cookie = "GeoRedirected=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
        });
    });
})(window.jQuery);

function flipContainerActivate(that, event) {
    var divisionForm = that.getElementsByClassName('division-form')[0];
    if (divisionForm) {
        divisionForm.style.display = 'block';
        if (!that.classList.contains('active')) {
            that.classList.add('active');
        }
    }
}

function flipContainerDeactivate(that, event) {
    var isAncestor = function (elem) {
        while (elem && elem !== document) {
            if (elem === that) {
                return true;
            }
            elem = elem.parentNode;
        }
        return false;
    };    
    var divisionForm = that.getElementsByClassName('division-form')[0];
    if (divisionForm) {
        if (document.activeElement && (!document.activeElement.classList.contains('form-control')||!isAncestor(document.activeElement))) {
            divisionForm.style.display = 'none';
            that.classList.remove('active');
        }
    }
}

function flipContainerToggle(that, event) {
    if (event && event.target && !event.target.classList.contains('form-control') && !event.target.classList.contains('division-submit')) {
        if (that.classList.contains('active')) {
            flipContainerDeactivate(that, event);
        } else {
            flipContainerActivate(that, event);
        }
    }
}
